import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirebaseAuthService } from '@dataclouder/app-auth';
import { firstValueFrom } from 'rxjs';
import { AppUserService } from 'src/app/core/services/app-user.service';

export const authUserGuard: CanActivateFn = async (route, state) => {
  const userService = inject(AppUserService);
  const firebaseAuthService = inject(FirebaseAuthService);
  const router = inject(Router);

  // 1. Check Firebase authentication state first
  const isAuthenticated = await firstValueFrom(firebaseAuthService.authState$);

  if (!isAuthenticated) {
    // TODO: Implement mobile-specific routing logic if needed
    // TODO:  Can i send to intro later not here instead in the routes?
    router.navigateByUrl('/auth/login');
    return false;
  }

  if (!userService.user()) {
    // 2. Load user data from your API
    try {
      // The `loadUser` method will only fetch from the API if the user is not already in the signal.
      await userService.refreshUserFromServer(true);
    } catch (error) {
      console.error('Failed to load user in auth guard, redirecting.', error);
      router.navigateByUrl('/auth/login');
      return false;
    }
  }

  if (userService.user()?.frontendSteps?.introTaken === 'pending') {
    // TODO: Implement mobile-specific routing logic if needed
    router.navigateByUrl('auth/intro');
    return false;
  }

  // 4. If all checks pass, allow access
  return true;
};
// Trigger re-evaluation
